import React from 'react'
import { Button } from 'antd'
import './index.css'

interface ButtonIconProps {
  buttonContent?: React.ReactNode;
  loading?: boolean;
  disabled?: boolean;
  htmlType?: 'submit' | 'button' | 'reset';
  holderStyles?: React.CSSProperties;
  onClick?: () => void;
}

const ButtonIcon: React.FC<ButtonIconProps> = ({
  buttonContent = <></>,
  loading = false,
  disabled = false,
  htmlType = 'button',
  holderStyles = {},
  onClick = () => {},
}) => {
  return (
    <div style={holderStyles} className="button-holder-icon">
      <Button
        type="primary"
        htmlType={htmlType}
        onClick={onClick}
        loading={loading}
        disabled={disabled}
      >
        {buttonContent}
      </Button>
    </div>
  )
}

export default ButtonIcon
